module.exports = __webpack_public_path__ + "img/compliance.49e03895.svg";